import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { CheckboxPrimitive } from '../checkbox-primitive/checkbox-primitive.js';
import { checkbox, visuals, root } from './manually-labeled-switch.css.js';

/**
 * Represents a physical toggle to turn a setting “on” or “off” where you need complete control over the placement of the label.
 * @see https://fpl.figma.design/components/switch/#manuallylabeledswitch
 */
const ManuallyLabeledSwitch = forwardRef(({ className, disabled, 'aria-disabled': ariaDisabled, onChange, ...props }, ref) => {
    const isEffectivelyDisabled = disabled || ariaDisabled;
    return (jsxs("span", { "data-fpl-component": "", className: clsx(root, className), "data-disabled": isEffectivelyDisabled || undefined, children: [jsx(CheckboxPrimitive, { ...props, ref: ref, className: checkbox, "aria-disabled": isEffectivelyDisabled || undefined, onChange: isEffectivelyDisabled ? undefined : onChange }), jsx("span", { className: visuals })] }));
});
ManuallyLabeledSwitch.displayName = 'ManuallyLabeledSwitch';

export { ManuallyLabeledSwitch };
//# sourceMappingURL=manually-labeled-switch.js.map
